import ContentContainer from '@fragments/Setting/ContentContainer';
import Device from '@fragments/Setting/Device';
import { isSpeakerChecked } from '@stores/selectors/device';
import { useAtomValue } from 'jotai';
import type { FC } from 'react';
import { EnterButton } from './style';

const Content: FC = () => {
  const deviceCheck = useAtomValue(isSpeakerChecked);

  const handleClickConfirm = () => {
    window.close();
  };

  return (
    <ContentContainer>
      <Device />
      <EnterButton onClick={handleClickConfirm} disabled={!deviceCheck}>
        환경 설정 완료
      </EnterButton>
    </ContentContainer>
  );
};

export default Content;
